import { render } from "./Elements.vue?vue&type=template&id=5d3d150e&scoped=true"
import script from "./Elements.vue?vue&type=script&lang=js"
export * from "./Elements.vue?vue&type=script&lang=js"

import "./Elements.vue?vue&type=style&index=0&id=5d3d150e&lang=less&scoped=true"

import exportComponent from "/var/www/eventgallery/build/tmpBuildDir/components/com_eventgallery/media/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3d150e"],['__file',"backend/vue/cacheclear/Elements.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d3d150e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d3d150e', __exports__)) {
    api.reload('5d3d150e', __exports__)
  }
  
  module.hot.accept("./Elements.vue?vue&type=template&id=5d3d150e&scoped=true", () => {
    api.rerender('5d3d150e', render)
  })

}


export default __exports__